import React from "react";
import styles from "./CoreIdea.module.css";
import Icon from "./Icon";
import { Link } from "react-router-dom";
import { classNames } from "primereact/utils";
import HeaderWithLeaf from "../../HeaderWithLeaf";

function NavigationSection({ initialValues }) {
  // const handleCardHover = (event) => {
  //   // Apply the transform effect for scaling
  //   event.target.style.transform = 'scale(1.1)';

  //   // Apply the opacity and background color changes

  //   event.target.style.backgroundColor = '';
  // };

  // const handleCardHoverExit = (event) => {
  //   event.target.style.transform = 'scale(1)';
  //   event.target.style.backgroundColor = 'var(--mustard)';
  // };

  return (
    <div className={classNames(styles.container, "mb-4")}>
      <img
        src="./assets/images/home/Group 244.webp"
        alt="Background"
        loading="lazy"
        className={styles.background}
      />
      <div
        className={classNames(
          styles.headingContainer,
          "section-p-spacing-top "
        )}
      >
        <HeaderWithLeaf text={initialValues?.mainHeading} />
      </div>
      <div
        className={`container ${styles.coreContainer}`}
        style={{ gap: "25px" }}
      >
        {initialValues?.card?.map((element, index) => (
          <div
            className={styles.coreIdea}
            key={index}
            style={{
              background: `url(${element?.image})`,
              backgroundSize: "cover",
              borderRadius: "5px",
              justifyContent: "end",
              width: "100%",
              height: "100%",
              aspectRatio: "1",
            }}
            // onMouseEnter={handleCardHover}
            // onMouseLeave={handleCardHoverExit}
          >
            <Link to={element.url}>
              <button className={styles.btn}>{element?.heading}</button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default React.memo(NavigationSection); // Memoize the NavigationSection;
